export default __webpack_public_path__ + "static/media/Illustration_2.2fc359f7.svg";